import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import ToastifyStyle from './ToastifyStyle';

export default function ToastifyContainer(props) {
  return (
    <React.Fragment>
      <ToastifyStyle />
      <ToastContainer {...props} position={toast.POSITION.BOTTOM_RIGHT} />
    </React.Fragment>
  );
}
